import { GameRoutes } from "./GamesRoutes";

export const GamesPage = () => {
    return <GameRoutes />
}